<template>
  <main class="container my-5">
    <article class="CardConfirmarPedido w-100">
      <div class="row d-flex">
        <hr class="mr-2" />
        <strong>Endereço de cobrança</strong>
        <hr class="ml-2" />
      </div>
      <div v-if="!this.btnLoading">
        <form
          @submit.prevent="salvarEndereco"
          class="row my-0 px-0 px-lg-4 py-0"
        >
          <div class="col-12">
            <div class="form-group">
              <label>CEP</label>
              <input
                type="text"
                @keyup.enter="getByCep('cepCobranca')"
                @blur="getByCep('cepCobranca')"
                class="form-control"
                v-model="cepCobranca"
                v-mask="'#####-###'"
                pattern=".{9}"
                required
              />
              <small class="text-muted" v-if="loadingCep">
                <span class="spinner-border spinner-border-sm"></span>
                Buscando seu CEP
                <span class="button-loader grey ml-2"></span>
              </small>
              <small class="text-muted" v-if="cepNaoLocalizado">
                CEP não localizado
              </small>
            </div>
            <div class="form-group">
              <label>Logradouro</label>
              <input
                type="text"
                class="form-control"
                v-model="enderecoCobranca.endereco"
                required
              />
            </div>
            <div class="form-group">
              <label for="exampleInputPassword1">Complemento</label>
              <input
                type="text"
                class="form-control"
                v-model="enderecoCobranca.complemento"
              />
            </div>
            <div class="row" style="margin: 0 -15px;">
              <div class="form-group col">
                <label for="exampleInputPassword1">Número</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="enderecoCobranca.numero"
                  required
                />
              </div>
              <div class="form-group col">
                <label for="exampleInputPassword1">Bairro</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="enderecoCobranca.bairro"
                  required
                />
              </div>
            </div>
            <div class="row" style="margin: 0 -15px;">
              <div class="form-group col-6">
                <label for="exampleInputPassword1">Cidade</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="enderecoCobranca.cidade"
                  required
                />
              </div>
              <div class="form-group col-6">
                <label for="exampleInputPassword1">UF</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="enderecoCobranca.estado"
                  required
                />
              </div>
            </div>
          </div>

          <div
            class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between"
          >
            <button
              class="btn btn_color_system px-5 mt-4 py-2"
              @click="$router.go(-1)"
            >
              VOLTAR
            </button>
            <button class="btn btn_color_system py-2 px-5 mt-4" type="submit">
              CONTINUAR
            </button>
          </div>
        </form>
        <div
          v-if="erro"
          class="card my-2 badge-danger text-center p-3 text-uppercase m-3"
        >
          {{ erro.title }}
        </div>
      </div>
      <!-- <div class="row d-flex assinar-plano-checkout fixed-bottom text-center">
        <div class="col-12 m-2 text-center">
          <small> <strong>Valor do plano</strong></small> <br />
          <span class="valor-plano">R$ {{ formatPrice(plano.valorMensal) }}
            /{{ plano.modeloCobranca.periodicidade }}</span>
          <br />
        </div>
      </div> -->
      <Loading v-if="btnLoading"></Loading>
    </article>
  </main>
</template>

<script>
import Loading from '@/components/Loading.vue'
import { enderecoNoWrap } from '../../shared/helpers/helpers'
import { APIService } from '../../APIService'
const apiService = new APIService()

export default {
  name: 'StepEndereco',
  components: { Loading },
  props: ['cep'],
  data() {
    return {
      MODULOS: window.MODULOS,
      plano: this.$store.state.simulacaoPlano,
      user: this.$store.state.user,
      enderecoUser: null,
      enderecoForm: false,
      loadingCep: false,
      cepNaoLocalizado: false,
      enderecoIgual: false,
      loadingCepEndereco: false,
      cepCobranca: '',
      btnLoading: false,
      erro: null,
      enderecoCobranca: {
        cep: '',
        endereco: '',
        complemento: '',
        numero: '',
        bairro: '',
        cidade: '',
        estado: '',
        pais: '',
      },
    }
  },
  created() {
    this.enderecoCobranca =
      this.user && this.user.pessoa.endereco
        ? this.user.pessoa.endereco
        : this.enderecoCobranca
    this.cepCobranca =
      this.user && this.user.pessoa.endereco
        ? this.user.pessoa.endereco.cep
        : null
  },
  methods: {
    formatPrice(value) {
      let val = ((value || 0) / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    getByCep(cepCobranca) {
      this.cepNaoLocalizado = false
      if (!cepCobranca) this.loadingCepEndereco = true
      if (!this.loadingCep) {
        this.loadingCep = true
        apiService
          .getCep(cepCobranca ? this.cepCobranca : this.cep)
          .then((res) => {
            if (res != '') {
              this.enderecoCobranca = res
              this.loadingCep = false
            } else {
              this.loadingCep = false
              this.cepNaoLocalizado = true
            }
          })
          .catch(() => {
            this.loadingCep = false
            this.cepNaoLocalizado = true
          })
          .finally(() => {
            if (!cepCobranca) this.loadingCepEndereco = false
          })
      }
    },
    salvarEndereco() {
      this.btnLoading = true
      this.enderecoCobranca.tipo = 'COBRANCA'
      apiService
        .salvarEndereco(this.enderecoCobranca)
        .then(() => {
          apiService.dadosApp().then((response) => {
            if (window.PIXEL_CODE) {
              window.fbq('track', 'CompleteRegistration')
            }
            this.user.pessoa.endereco = this.enderecoCobranca
            
            if (this.$route.query.nextUrl != null) {
              if(this.MODULOS.ASSINATURA == true && this.plano.modeloCobranca.formaPagamento == 'BOLETO') {
                apiService
                  .contratarPlano(this.plano)
                  .then((res) => {
                    this.plano = res
                    this.$router.push(`/planos/checkout/boleto/${this.plano.planoId}/${this.plano.recorrenciaId}`);
                  }).finally(() => (this.btnLoading = false));
              } else {
                this.$router.push(this.$route.query.nextUrl)
              }
            } else {
              response.pessoa.endereco &&
                this.$emit('goToStep', 'pedido') &&
                this.$emit('enderecoSalvo', true)
            }
          })
        })
        .catch((error) => {
          this.erro = error.response.data
        })
        .finally(() => {  
          if(this.MODULOS.ASSINATURA == true && this.plano.modeloCobranca.formaPagamento == 'BOLETO') {
            (this.btnLoading = true)
          } else {
            (this.btnLoading = false)
          }
        })
    },
    endereco(end) {
      return enderecoNoWrap(end)
    },
    goToStep(step) {
      this.$emit('goToStep', step)
    },
  },
}
</script>
<style scoped lang="scss"></style>
